const getFaqCategoryListApi = async (options?: ApiRestOptions) => {
  return apiFetchRequest<ApiRestResult<FaqCategoryListResponse>>("/data/faq/categories", options);
};

export { getFaqCategoryListApi };
